"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var attending_1 = require("../../../model/attending");
var diagnosis_web_socket_service_1 = require("../../../../diagnosis/service/diagnosis-web-socket.service");
var vehicle_service_1 = require("../../../../diagnosis/service/vehicle.service");
var authentication_service_1 = require("../../../../shared/service/authentication.service");
var attending_score_1 = require("../../../model/attending-score");
var attending_type_1 = require("../../../constants/attending-type");
var monitoring_step_status_1 = require("../../../constants/monitoring-step-status");
var monitoring_step_type_1 = require("../../../constants/monitoring-step-type");
var attending_service_1 = require("../../../service/attending.service");
var MonitoringComponent = /** @class */ (function () {
    function MonitoringComponent(_diagnosisNotification, _vehicleService, _authService, _attendingService) {
        this._diagnosisNotification = _diagnosisNotification;
        this._vehicleService = _vehicleService;
        this._authService = _authService;
        this._attendingService = _attendingService;
        this._attending = new attending_1.Attending();
        this.txOnUpdateMonitoring = new core_1.EventEmitter();
        this.txOnCancel = new core_1.EventEmitter();
        this.txOnAssignMonitoringToUser = new core_1.EventEmitter();
        this.txOnUnassignMonitoringToUser = new core_1.EventEmitter();
        this.txOnUpdateAttendingInfo = new core_1.EventEmitter();
        this.txOnConvertAttending = new core_1.EventEmitter();
        this.files = new Array();
        this.modalActions = new core_1.EventEmitter();
        this.attendingInfoPolling = null;
        this.MONITORING = 'MONITORING';
        this.attendingIsAuditOrMaintenance = false;
        this.conversionButtonText = '';
        this.setEmptyEntities();
    }
    MonitoringComponent.prototype.ngAfterViewChecked = function () {
        try {
            Materialize.updateTextFields();
        }
        catch (e) { }
    };
    Object.defineProperty(MonitoringComponent.prototype, "attending", {
        get: function () {
            return this._attending;
        },
        set: function (attending) {
            this._attending = __assign({}, attending, { attendingInfo: __assign({}, attending.attendingInfo) });
            this.authenticatedUser = this._authService.getUserFromLocalStorage();
            this.setUpObservers();
            this.showStep();
            this.attendingIsMaintenanceOrAudit();
            this.tryUpdateAttendingInfo();
            this.setEmptyEntities();
        },
        enumerable: true,
        configurable: true
    });
    MonitoringComponent.prototype.ngOnInit = function () {
    };
    MonitoringComponent.prototype.cancel = function () {
        this.txOnCancel.emit(this.attending);
    };
    MonitoringComponent.prototype.canEdit = function () {
        return (this.attending.monitoring.canEdit || this.attending.monitoring.canEdit === undefined) && this.editable;
    };
    MonitoringComponent.prototype.canView = function () {
        return this.attending.monitoring.canView && !this.canEdit();
    };
    MonitoringComponent.prototype.isUserAssigned = function () {
        try {
            return this.attending.monitoring.argosUser.id === this.authenticatedUser.id;
        }
        catch (e) {
            return false;
        }
    };
    MonitoringComponent.prototype.assignToMe = function () {
        this.attending.monitoring.argosUser = this.authenticatedUser;
        this.txOnAssignMonitoringToUser.emit();
    };
    MonitoringComponent.prototype.unassignToMe = function () {
        this.attending.monitoring.argosUser = {};
        this.txOnUnassignMonitoringToUser.emit();
    };
    MonitoringComponent.prototype.rescheduleAttending = function () {
        this._attendingService.reschedule(this._attending.id);
    };
    MonitoringComponent.prototype.attendingIsMaintenanceOrAudit = function () {
        if (this.attending) {
            this.attendingIsAuditOrMaintenance =
                (this.attending.type === attending_type_1.AttendingType.AUDIT || this.attending.type === attending_type_1.AttendingType.MAINTENANCE)
                    && this.attending.attendingInfo.conversion && !this.attending.attendingInfo.conversion.converted;
            if (this.attendingIsAuditOrMaintenance) {
                this.conversionButtonText =
                    this.attending.attendingInfo.conversion.type === attending_type_1.AttendingType.AUDIT ? 'TRANSFORMAR EM AUDITORIA' : 'TRANSFORMAR EM MANUTENÇÃO';
            }
        }
    };
    MonitoringComponent.prototype.displayStep = function (type) {
        if (type === monitoring_step_type_1.MonitoringStepType.PRE_EVALUATION) {
            return this._attending.monitoring.preEvaluationStep === monitoring_step_status_1.MonitoringStepStatus.CURRENT;
        }
        else if (type === monitoring_step_type_1.MonitoringStepType.VALIDATION) {
            return this._attending.monitoring.validationStep === monitoring_step_status_1.MonitoringStepStatus.CURRENT;
        }
        else if (type === monitoring_step_type_1.MonitoringStepType.CONCLUSION) {
            return this._attending.monitoring.conclusionStep === monitoring_step_status_1.MonitoringStepStatus.CURRENT;
        }
        return false;
    };
    MonitoringComponent.prototype.setEmptyEntities = function () {
        try {
            this.attending.technicianScore = this.attending.technicianScore || new attending_score_1.AttendingScore();
        }
        catch (e) { }
    };
    MonitoringComponent.prototype.tryUpdateAttendingInfo = function () {
        var _this = this;
        if (this.canEdit() && !this.attendingInfoPolling) {
            this.attendingInfoPolling = setInterval(function () {
                if (_this.attending) {
                    _this.emitAttendingInfoUpdateRequest();
                }
            }, 20000);
        }
    };
    MonitoringComponent.prototype.emitAttendingInfoUpdateRequest = function () {
        this.txOnUpdateAttendingInfo.emit(this.attending.attendingInfo.id);
    };
    MonitoringComponent.prototype.showStep = function () {
        if (this.attending.orderedSteps && this.attending.currentStep === this.MONITORING) {
            this.setIsVisible();
            this.setIsEditable();
        }
    };
    MonitoringComponent.prototype.setIsVisible = function () {
        var _this = this;
        if (this.attending.orderedSteps.includes(this.MONITORING)
            && this.authenticatedUser.stepViews.find(function (view) { return view.stepViewType === _this.MONITORING; })) {
            this.attending.monitoring.canView = true;
        }
        else {
            this.attending.monitoring.canView = false;
        }
    };
    MonitoringComponent.prototype.setIsEditable = function () {
        var _this = this;
        if (this.authenticatedUser.stepKeys.find(function (view) { return view.stepType === _this.MONITORING; })) {
            this.attending.monitoring.canEdit = true;
        }
        else {
            this.attending.monitoring.canEdit = false;
        }
    };
    MonitoringComponent.prototype.setUpObservers = function () {
        var _this = this;
        if (this.canEdit()) {
            this._vehicleService.find$
                .subscribe(function (vehicles) {
                _this.vehicle = vehicles.find(function (vehicle) { return vehicle.plate === _this.attending.vehiclePlate; });
            });
        }
    };
    MonitoringComponent.ctorParameters = function () { return [{ type: diagnosis_web_socket_service_1.DiagnosisWebSocketService }, { type: vehicle_service_1.VehicleService }, { type: authentication_service_1.AuthenticationService }, { type: attending_service_1.AttendingService }]; };
    return MonitoringComponent;
}());
exports.MonitoringComponent = MonitoringComponent;
//# sourceMappingURL=monitoring.component.js.map


// WEBPACK FOOTER //
// monitoring.component.js